import { useCallback } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import RightPanelEmptyState from '../components/RightPanelEmptyState'
import ItineraryContainer from '../containers/ItineraryContainer'
import { useItineraryContext } from '../contexts/ItineraryContext'
import { EmptyStateWrapper } from '../styles/layoutStyles'
import { useTripChatMobileAppShell } from './TripChatMobileAppShell'

const TimelineRoot = styled.div`
  --trip-plan-canvas-background: ${props => props.theme.palette.neutral.surface.normalBackground};
  --trip-plan-canvas-padding: ${rem(16)};
  --trip-plan-canvas-narrow-padding: ${rem(16)};

  height: 100%;
  min-height: 0;
  overflow: hidden;
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
`

function TripChatMobileTimelineView() {
  const { activeTab, setActiveTab } = useTripChatMobileAppShell()
  const { hasItineraryData } = useItineraryContext()
  const isTimelineActive = activeTab === 'timeline'
  const handleAskAIAction = useCallback(() => {
    setActiveTab('chat')
  }, [setActiveTab])

  if (!hasItineraryData) {
    return (
      <EmptyStateWrapper padding={24}>
        <RightPanelEmptyState variant="timeline" />
      </EmptyStateWrapper>
    )
  }

  return (
    <TimelineRoot data-testid="trip-chat-mobile-timeline-view">
      <ItineraryContainer
        visible={isTimelineActive}
        selectedDayItineraryId={undefined}
        selectedStop={undefined}
        enableMapActions={false}
        onAskAIAction={handleAskAIAction}
      />
    </TimelineRoot>
  )
}

export default TripChatMobileTimelineView
